import BtnHeader from "@/components/UI/BtnHeader";
import BtnHeaderPrime from "@/components/UI/BtnHeaderPrime";

export default [BtnHeader, BtnHeaderPrime];
